import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Cart quantity selector with custom tile limit toast.
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  showTileLimitToast() {
    let toast = document.querySelector('.tile-limit-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'tile-limit-toast';
      toast.innerText = 'Maximum 1 tile set per order.';
      document.body.appendChild(toast);
    }

    toast.classList.add('show');

    setTimeout(() => {
      toast.classList.remove('show');
    }, 2500);
  }

  increaseQuantity(event) {
    const handle = this.dataset.productHandle;
    const { value } = this.getCurrentValues();

    if (handle === 'cabana-lounge-tiles' && value >= 1) {
      event?.preventDefault();
      event?.stopPropagation();
      this.showTileLimitToast();
      return;
    }

    super.increaseQuantity(event);
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = value <= min;

    if (this.dataset.productHandle === 'cabana-lounge-tiles') {
      plusButton.disabled = false;
    } else {
      plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
    }
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}